<div class="success-bar">
  <img src="../../../../../assets/images/message-icon.png" alt=""  >
  <h4 class="item-title"> Mail Sent Successfully..!</h4>
  <p class="item-sub-title">We will get back to you soon.</p>
</div>
